<template>
    <div>
        <data-view-sidebar :isSidebarActive="addDataSidebar" @closeSidebar="toggleSidebar" :data="sidebarData" />

        <div id="data-list-list-view" class="mr-2 vs-con-loading__container">
            <vs-table ref="table" multiple v-model="selectedCoupons" pagination :max-items="20" search :data="coupons" no-data-text="Nenhum cupom encontrado">
                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                    <div class="flex flex-wrap-reverse items-center data-list-btn-container">

                    <!-- ACTION - DROPDOWN -->
                        <div @click="addDataSidebar = true" class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary">
                            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                            <span class="ml-2 text-base text-primary">Adicionar</span>
                        </div>

                    <!-- ADD NEW -->
                        <div
                          @click="confirmDeleteCoupons" 
                          id="remove-coupons" 
                          class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary">
                            <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" />
                            <span class="ml-2 text-base text-primary">Remover</span>
                        </div>
                    </div>

                    <!-- ITEMS PER PAGE -->
                    <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
                    <!-- <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                        <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ products.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : products.length }} of {{ queriedItems }}</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div> -->
                    <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                    <vs-dropdown-menu>

                        <vs-dropdown-item @click="itemsPerPage=4">
                        <span>4</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=10">
                        <span>10</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=15">
                        <span>15</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=20">
                        <span>20</span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <template slot="thead">
                    <vs-th sort-key="id">CUPOM</vs-th>
                    <vs-th sort-key="description" width="350">Descrição</vs-th>
                    <!-- <vs-th sort-key="expires">Expiração</vs-th> -->
                    <!-- <vs-th sort-key="minValue">Valor Mín.</vs-th> -->
                    <vs-th sort-key="utilizations">Utilizações</vs-th>
                    <vs-th sort-key="value">Valor</vs-th>
                    <vs-th sort-key="value">Situação</vs-th>
                    <vs-th>Ações</vs-th>
                </template>

                    <template slot-scope="{data}">
                    <tbody>
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                            <vs-td>
                                <p class="product-name font-medium">{{ tr.id }}</p>
                            </vs-td>

                            <vs-td>
                                <p class="product-category">{{ getTruncatedText(tr.description) }}</p>
                            </vs-td>

                            <!-- <vs-td>
                                <p v-if="tr.expires">{{ tr.expires | moment('DD/MM/YYYY') }}</p>
                                <p v-else class="text-center"> - </p>
                            </vs-td> -->
<!-- 
                            <vs-td>
                                <p class="product-category">{{ tr.minValue | currency }}</p>
                            </vs-td> -->

                            <vs-td>
                                <div class="vx-row ml-2 -mb-4">
                                    <vs-icon 
                                        class="mr-2"
                                        style="font-size: 20px"
                                        icon-pack="material-icons"
                                        :icon="tr.utilizations > 1 ? 'people' : 'person'"/>
                                    <p class="product-category">{{ tr.utilizations }} / {{ tr.maxUtilizations }}</p>
                                </div>
                                <vs-progress 
                                  :percent="(tr.utilizations * 100) / tr.maxUtilizations" 
                                  :color="((tr.utilizations * 100) / tr.maxUtilizations) > 99 ? 'danger' : 'success'" 
                                  class="shadow-md" />
                            </vs-td>

                            <vs-td>
                                <p class="product-category">{{ tr.value | currency }}</p>
                            </vs-td>

                            <vs-td>
                                <vs-chip color="danger" v-if="tr.expires < new Date() && tr.expires"> Vencido </vs-chip>
                                <vs-chip color="danger" v-else-if="tr.utilizations >= tr.maxUtilizations && tr.maxUtilizations > 0"> Limite Atingido </vs-chip>
                                <vs-chip color="success" v-else> Disponível </vs-chip>
                            </vs-td>

                            <!-- <vs-td>
                                <vs-progress :percent="Number(tr.popularity)" color="danger" class="shadow-md" />
                            </vs-td> -->

                            <vs-td class="whitespace-no-wrap">
                              <feather-icon icon="EditIcon" svgClasses="w-6 h-6 hover:text-primary stroke-current" @click.stop="editCoupom(tr)" />
                            </vs-td>

                        </vs-tr>
                    </tbody>
                </template>
            </vs-table>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import { truncateText } from '@/assets/utils/misc.js'
    import DataViewSidebar from '@/components/coupons/DataViewSidebar' 
    import moment from 'moment'

    export default {
        components : {
            DataViewSidebar
        },

        data () {
            return {
                addDataSidebar : false,
                selectedCoupons : [],
                sidebarData : {}
            }
        },

        mounted () {
            this.getAllCoupons()
            this.sidebarData = {}
        },

        computed : {
            coupons : {
                get () {
                    return this.coupons 
                },
                set () {

                }
            },

            ...mapState('coupons', ['coupons'])
        },

        methods : {
            toggleSidebar (val = false) {
                if(!val) this.sidebarData = {}
                this.addDataSidebar = val
            },

            editCoupom (coupon) {  
                let newCoupon = {...coupon}
                
                this.sidebarData = newCoupon
                this.addDataSidebar = true
            },

            async getAllCoupons () {
                try {
                    this.$vs.loading({ container : '#data-list-list-view', scale : 1 })
                    await this.fetchCoupons()
                } catch (err) {
                    this.$error({
                        title : 'Erro ao listar cupons de descontos',
                        content : err.message,
                        zIndex : 999999
                    })
                } finally {
                    this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
                }
            },

            confirmDeleteCoupons () {
              if(!this.selectedCoupons.length) return
              let msg = this.selectedCoupons.length > 1 ? 'os cupons' : 'o cumpom'
              this.$confirm({
                zIndex: 9999999,
                title: 'Remover cupom',
                content: `Deseja realmente remover ${msg} "${this.selectedCoupons.map(a => a.id).join(', ')}"?`,
                okText: 'Remover',
                okType: 'danger',
                cancelText: 'Não',
                onOk: () => {
                  this.deleteCoupons();
                },
              });
            },

            async deleteCoupons () {
              try {
                const selectedCoupons = this.selectedCoupons.map(a => a.id) || []
                if(selectedCoupons.length) {
                  this.$vs.loading({ container : '#remove-coupons', scale : 1 })
                  await this.removeCoupons(selectedCoupons)
                  this.selectedCoupons = []
                }
              } catch (err) {
                this.$error({
                    title : 'Erro ao remover',
                    content : err.message,
                    zIndex : 999999
                })
              } finally {
                this.$vs.loading.close('#remove-coupons > .con-vs-loading')
              }
            },

            getTruncatedText (str) {
                return truncateText(str, 35)
            },
            ...mapActions('coupons', ['fetchCoupons', 'removeCoupons'])
        }
    }
</script>

<style lang="scss">
    #data-list-list-view {
    .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>